import { apiRequest } from "./apiClient";
import { rt } from "../i18n/runtime";

const kullaniciAileIdBul = (user) => {
  if (user?.familyId) return user.familyId;
  if (Array.isArray(user?.families)) {
    const aktifAile = user.families.find((f) => f?.familyId);
    if (aktifAile?.familyId) return aktifAile.familyId;
  }
  return "";
};

const bildirimAlabilecekKullanicilariHazirla = (kullanicilar = []) =>
  kullanicilar
    .map((u) => ({ ...u, familyId: kullaniciAileIdBul(u) }))
    // Sistem duyuruları ve kullanıcıya özel bildirimler backend'de familyId olmadan da gönderilebilir.
    // Aile üyeliği olmayan veya familyId alanı boş dönen kullanıcıları 0 hedefe düşürme.
    .filter((u) => u?.uid);

const aktifKullaniciMi = (u = {}) => {
  const status = String(u.status || u.raw?.status || "active").toLowerCase();
  if (["deleted", "passive", "inactive", "disabled", "removed"].includes(status)) return false;
  if (u.deletedAt || u.raw?.deletedAt || u.raw?.deleted_at) return false;
  return Boolean(u.uid);
};

const tarihMs = (value) => {
  const ms = Date.parse(value || "");
  return Number.isFinite(ms) ? ms : 0;
};

export async function tumUygulamaKullanicilariniGetir() {
  const data = await apiRequest(`/notifications/admin/users?_=${Date.now()}`);
  return (data?.items || [])
    .map((u) => ({ ...u, familyId: kullaniciAileIdBul(u) }))
    .filter(aktifKullaniciMi)
    .sort((a, b) => {
      const byDate = tarihMs(b.createdAt || b.raw?.createdAt) - tarihMs(a.createdAt || a.raw?.createdAt);
      if (byDate !== 0) return byDate;
      return String(b.userId || b.id || "").localeCompare(String(a.userId || a.id || ""));
    });
}

export async function adminBildirimSablonlariniGetir() {
  const data = await apiRequest("/notifications/admin/message-templates");
  return data?.templates || null;
}

export async function adminBildirimSablonlariniKaydet(templates) {
  const data = await apiRequest("/notifications/admin/message-templates", {
    method: "PUT",
    body: JSON.stringify({ templates }),
  });
  return data?.templates || templates;
}

export async function seciliKullanicilaraBildirimGonder({
  kullanicilar = [],
  baslik,
  aciklama,
  gonderenUid,
}) {
  const hedefler = bildirimAlabilecekKullanicilariHazirla(kullanicilar);
  if (hedefler.length === 0) throw new Error(rt("service.error.noNotifyUsers"));

  const data = await apiRequest("/notifications/admin/send-users", {
    method: "POST",
    body: JSON.stringify({
      baslik,
      aciklama,
      gonderenUid,
      hedefTipi: "users",
      hedefUidler: hedefler.map((u) => u.uid),
      hedefSayisi: hedefler.length,
      bildirimType: "system",
      kaynak: "notificationAdmin",
      url: "/",
    }),
  });

  return data?.adet ?? data?.count ?? hedefler.length;
}

export async function tumKullanicilaraSistemDuyurusuGonder({
  kullanicilar = [],
  baslik,
  aciklama,
  baslikKey = null,
  aciklamaKey = null,
  baslikI18n = null,
  aciklamaI18n = null,
  gonderenUid,
}) {
  const hedefler = bildirimAlabilecekKullanicilariHazirla(kullanicilar);
  if (hedefler.length === 0) throw new Error(rt("service.error.noNotifyUsers"));

  const data = await apiRequest("/notifications/admin/send-all", {
    method: "POST",
    body: JSON.stringify({
      baslik,
      aciklama,
      baslikKey,
      aciklamaKey,
      baslikI18n,
      aciklamaI18n,
      gonderenUid,
      hedefTipi: "allUsers",
      hedefUidler: hedefler.map((u) => u.uid),
      hedefSayisi: hedefler.length,
      bildirimType: "systemAnnouncement",
      kaynak: "notificationAdmin",
      url: "/",
    }),
  });

  return {
    targetCount: data?.targetCount ?? hedefler.length,
    inAppCreated: data?.inAppCreated ?? data?.adet ?? data?.count ?? 0,
    pushSent: data?.pushSent ?? 0,
    pushFailed: data?.pushFailed ?? 0,
    ok: data?.ok !== false,
    message: data?.message || "",
  };
}
